export function getMinutes(time: string): number {
	const [minutes] = time.split(':').map(Number);
	return minutes;
}
